import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TRACK_STATE_STATUS, TRACK_STATUS_CLOSED, TRACK_STATUS_OPEN } from "../../config/constants";
import { tracksColors } from "../../config/styles";

const TracksDebug = ({ onChangeToStatus, onChangeToDifficulty, onToggleTrack, tracksData, onToggleTrackStatus, trackState }) => {
	const filterStringFromStore = localStorage.getItem('debug-filter-string');
	const [filterString, setFilterString] = useState(filterStringFromStore || '');

	const getFilteredCondition = trackName => {
		let result = false;
		const stringsMap = filterString.split(';');

		stringsMap.map(filterStr => {
			if (trackName.includes('Track' + filterStr.toUpperCase()))
				result = true;
		});

		return result;
	};

	return (
		<div className="tracks-debug">
			<div className="tracks-debug-buttons-wrap">
				<button onClick={onChangeToStatus}>Change to status</button>
				<button onClick={onChangeToDifficulty}>Change to diff</button>
			</div>

			<div>
				Filter by name:
				<input
					type="text"
					value={filterString}
					onChange={e => {
						localStorage.setItem('debug-filter-string', e.target.value);
						setFilterString(e.target.value);
					}}
				/>
			</div>

			<table>
				<thead>
				<tr>
					<th>Name</th>
					<th>👁️</th>
					<th>Status</th>
				</tr>
				</thead>

				<tbody>
				{Object.keys(tracksData).map(trackName => {
					if ((filterString !== '' && getFilteredCondition(trackName)) || filterString === '') {
						const trackColor = trackState === TRACK_STATE_STATUS ? (tracksData[trackName].status === TRACK_STATUS_OPEN ? tracksColors.open : tracksColors.closed) : null;
						return (
							<tr key={trackName}>
								<td
									className={['trackNameDiff' + tracksData[trackName].difficulty,]}
									style={{ color: trackColor }}
								>
									<span style={{ color: trackColor, marginRight: 5 }}>&#9679;</span>
									{trackName}
								</td>

								<td>
									<label style={{ display: 'block' }}>
										<input
											type="checkbox"
											name={trackName}
											checked={tracksData[trackName].isShow}
											onChange={() => onToggleTrack(trackName)}
										/>
									</label>
								</td>

								<td>
									<label style={{ display: 'block' }}>
										<select
											value={tracksData[trackName].status}
											onChange={event => onToggleTrackStatus(trackName, event.target.value)}
										>
											<option value={TRACK_STATUS_OPEN}>Open</option>
											<option value={TRACK_STATUS_CLOSED}>Closed</option>
										</select>
									</label>
								</td>
							</tr>
						)
					}

					return null;
				})}
				</tbody>
			</table>
		</div>
	);
};

TracksDebug.propTypes = {
	tracksData: PropTypes.object.isRequired
};

export default TracksDebug;
